import { AfterContentInit, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CertificateService } from '@app/services';

export type ModalResult = void;
export interface ModalPublicProperties {
  certificate: string;
}

export enum CertAttributeName {
  CountryName = 'countryName',
  OrganizationName = 'organizationName',
  StateOrProvinceName = 'stateOrProvinceName',
  LocalityName = 'localityName',
  OrganizationalUnitName = 'organizationalUnitName',
  CommonName = 'commonName'
}

@Component({
  selector: 'app-certificate-modal',
  templateUrl: './certificate-modal.component.html',
  styleUrls: ['./certificate-modal.component.scss'],
  standalone: false
})
export class CertificateModalComponent implements ModalPublicProperties, AfterContentInit {
  @Input() certificate: string;
  subject: {
    countryName: string;
    organizationName: string;
    stateOrProvinceName: string;
    localityName: string;
    organizationalUnits: string[];
    commonName: string;
  };

  issuer: {
    countryName: string;
    organizationName: string;
    organizationalUnitName: string;
    commonName: string;
  };

  validity: {
    serialNumber: string;
    validFrom: Date;
    validTo: Date;
  };

  constructor(
    public modal: NgbActiveModal,
    private certificateService: CertificateService
  ) {}

  ngAfterContentInit() {
    if (!this.certificate) return;

    const cert = this.certificateService.parsePem(this.certificate);
    if (!cert) return;

    this.subject = {
      countryName: this.certificateService.getAttribute(cert.subject.attributes, CertAttributeName.CountryName),
      organizationName: this.certificateService.getAttribute(cert.subject.attributes, CertAttributeName.OrganizationName),
      stateOrProvinceName: this.certificateService.getAttribute(cert.subject.attributes, CertAttributeName.StateOrProvinceName),
      localityName: this.certificateService.getAttribute(cert.subject.attributes, CertAttributeName.LocalityName),
      organizationalUnits: this.certificateService.getAllAttributes(cert.subject.attributes, CertAttributeName.OrganizationalUnitName),
      commonName: this.certificateService.getAttribute(cert.subject.attributes, CertAttributeName.CommonName)
    };

    this.issuer = {
      countryName: this.certificateService.getAttribute(cert.issuer.attributes, CertAttributeName.CountryName),
      organizationName: this.certificateService.getAttribute(cert.issuer.attributes, CertAttributeName.OrganizationName),
      organizationalUnitName: this.certificateService.getAttribute(cert.issuer.attributes, CertAttributeName.OrganizationalUnitName),
      commonName: this.certificateService.getAttribute(cert.issuer.attributes, CertAttributeName.CommonName)
    };

    this.validity = {
      serialNumber: cert.serialNumber,
      validFrom: cert.validity.notBefore,
      validTo: cert.validity.notAfter
    };
  }
}
